import { useEffect, useState } from 'react';
import { ScreenType } from '../../../../common/view-model';
import { UserMenuComponent } from '../../../authentication/user-menu/userMenuComponent';
import { IrisAuthenticationState } from '../../../authentication/model';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/AppReducer';
import { PROFILE_ROUTES } from '../../../../common/constants';
import { useWindowSize } from '../../../../hooks/useWindowSize';
import { useLocation } from 'react-router';
import useLocalStorage from '../../../../hooks/useLocalStorage';
import './AuthenticatedMenuComponent.scss';

export default function AuthenticathedMenuComponent() {
	const location = useLocation();
	const { width } = useWindowSize();
	const mobileWidthBreakpoint = 743;
	const currentEvent = useSelector(
		(state: RootState) => state.appState.storeState?.getCurrentEvent
	);
	const userState = useSelector((state: RootState) => state.appState.userState?.user);
	const { deviceScreen } = useSelector((state: RootState) => state.appState);
	const [userProfileState, setState] = useState({ ...IrisAuthenticationState });
	const [userIconState, setUserIconState] = useState('white');
	const [isOnProfile, setIsOnProfile] = useState<boolean>(false);
	const [showHubNotification] = useLocalStorage('hub-notification', true);

	const currentPath = location.pathname;
	const handleShowMenu = () => {
		setState({ ...userProfileState, showMenu: !userProfileState.showMenu });
	};
	const handleIconHover = () => {
		setUserIconState('blue');
	};
	const handleIconLeave = () => {
		if (userProfileState.showMenu) {
			setUserIconState('blue');
		} else {
			setUserIconState('white');
		}
	};
	const onMenuClose = () => {
		setState({ ...userProfileState, showMenu: false });
		setUserIconState('white');
	};

	useEffect(() => {
		document.addEventListener('mouseup', function (event) {
			const obj = document.getElementById('user-menu');
			if (obj && !obj.contains(event.target as any)) {
				setState({ ...userProfileState, showMenu: false });
				setUserIconState('white');
			}
		});
	}, []);

	useEffect(() => {
		const path = currentPath.replace(/^\/+/, '');
		const onProfile = Object.values(PROFILE_ROUTES).includes(path);
		setIsOnProfile(onProfile);
	}, [currentPath]);
	return (
		<div className='authentication' data-testid='authentication'>
			<div className='col'>
				<div className='row'>
					<div
						data-testid='user-icon'
						className={`user-icon ${
							userProfileState.showMenu && deviceScreen !== ScreenType.MOBILE ? ' active' : ''
						}`}
						onClick={handleShowMenu}
						onMouseEnter={() => deviceScreen !== ScreenType.MOBILE && handleIconHover()}
						onMouseLeave={handleIconLeave}
					>
						<div
							className={`${
								showHubNotification && userState?.isBrandAdmin ? 'circle-notification' : ''
							}`}
						></div>
						<i
							data-testid='ri-user-line'
							className={`${
								deviceScreen !== ScreenType.MOBILE
									? isOnProfile
										? 'ri-user-fill'
										: 'ri-user-line'
									: 'ri-menu-line'
							} ${deviceScreen !== ScreenType.MOBILE ? 'blue' : 'white'} ${userIconState}${
								userProfileState.showMenu ? ' active' : ''
							}`}
						></i>
					</div>
				</div>
				<div className='row' data-testid='user-menu'>
					{userProfileState.showMenu && (
						<UserMenuComponent
							onClose={onMenuClose}
							mobileView={deviceScreen === ScreenType.MOBILE || width <= mobileWidthBreakpoint}
							eventLink={currentEvent?.floorMapUrl}
						/>
					)}
				</div>
			</div>
		</div>
	);
}
